import { render, staticRenderFns } from "./NewSucceed.vue?vue&type=template&id=1bef9b5f&scoped=true&"
import script from "./NewSucceed.vue?vue&type=script&lang=js&"
export * from "./NewSucceed.vue?vue&type=script&lang=js&"
import style0 from "./NewSucceed.vue?vue&type=style&index=0&id=1bef9b5f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef9b5f",
  null
  
)

export default component.exports